import React, {
  Component,
  useContext,
  useState,
  useRef,
  useEffect,
} from "react";
import { MdArrowDropDown, MdEdit } from "react-icons/md";
import { Menu, MenuItem, Button, Divider, IconButton } from "@material-ui/core";
import { observer, useObserver } from "mobx-react";
import { ContainerStoreContext } from "../ContainerStore";
import { PackStoreContext } from "../../Pack/PackStore";

import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { StyledTooltip } from "../../common/utils/StyledTooltip";
import SheetActions from './SheetActions';
import COLORS from "scss/colors.module.scss";
import { cloneDeep } from "lodash";
import ArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

const useStyles = makeStyles((theme) => ({
  customTooltip: {
    backgroundColor: theme.palette.common.black,
  },
  root: {
    "& > .icon": {
      display: "none"
    },
    "&:hover": {
      "& > .icon": {
        display: "inline-block"
      }
    }
  }
}));

function ReportsMenu(props) {
  const { view, views, onViewChange, saveView, containerStore, handleEditReport, deleteView } = useData();
  const { renameSheet, markasDefaultReport } = usePackData();
  const [anchorEl, setAnchorEl] = useState(false);
  const [isOverFlow, setIsOverFlow] = useState(false);
  const [isNameEditing, setIsNameEditing] = useState(false);
  const [isShowCreateViewOptions, setIsShowCreateViewOptions] = useState(false);
  const viewNameRef = useRef();
  const createViewRef = useRef();
  const handleClose = () => setAnchorEl(false);
  const handleViewChange = (e) => {
    containerStore.resetRunningReportData(false);
    onViewChange(e);
    handleClose();
  };
  const handleCloseMenus = () => {
    setIsShowCreateViewOptions(false);
    handleClose();
  }
  const classes = useStyles();
  const currentView = cloneDeep(view);
  if (containerStore.isViewInEditMode && containerStore.initialViewId) {
    currentView.id = containerStore.initialViewId;
  }

  useEffect(() => {
    let hasOverFlow =
      viewNameRef.current.scrollWidth > viewNameRef.current.clientWidth;
    if (hasOverFlow !== isOverFlow) {
      setIsOverFlow(hasOverFlow);
    }
  }, [view.name, isOverFlow]);

  const changeViewName = async (e) => {
    setIsNameEditing(false);
    if (view.name === e.target.value) {
      return;
    }
    if (view.is_main_view === "1") {
      renameSheet(e.target.value, { id: view.list_id });
    } else {
      view.name = e.target.value;
      await saveView(view);
      const viewIndex = views.findIndex((v) => v.id === view.id);
      if (viewIndex !== -1) {
        views[viewIndex].name = view.name;
      }
    }
  };
  

  if (isNameEditing) {
    return (
      <input
        className="activeSheet"
        defaultValue={view.name}
        onChange={(e) => {}}
        onBlur={changeViewName}
        onFocus={(e) => {
          e.target.select();
        }}
        onKeyDown={async (e) => {
          if (e.key === "Enter") {
            changeViewName(e);
          }
          if (e.key === "Escape") {
            setIsNameEditing(false);
          }
        }}
        autoFocus={true}
        style={{
          borderRadius: 5,
          border: "2px solid " + props.themeColor,
          color: COLORS.TEXT_COLOR,
          paddingLeft: 10,
          paddingRight: 10,
          marginLeft: 5,
          minWidth: 250,
          outline: "none",
        }}
      />
    );
  }

  return (
    <React.Fragment>
      <StyledTooltip
        title={view.name}
        classes={{
          tooltip: classes.customTooltip,
        }}
        disableHoverListener={!isOverFlow}
      >
        <ViewButton onClick={(e) => setAnchorEl(e.target)}>
          {containerStore?.listConfig?.list?.is_log_sheet != 1 &&
            <MdArrowDropDown
            className="h-100"
            style={{
              color: "#212121",
              fontSize: 20,
              cursor: "pointer",
            }}
          />}
          <ViewName screenWidth={window.screen.width} ref={viewNameRef}>
            {view.name}
          </ViewName>
        </ViewButton>
      </StyledTooltip>
      {containerStore?.listConfig?.list?.is_log_sheet != 1 &&
        <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        PaperProps={{
          style: {
            maxHeight: `500px`,
            minWidth: `180px`
          },
        }}
        // TransitionComponent={Fade}
      >
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {views.map((view) => (
          <MenuItem key={view.id} onClick={handleViewChange} value={view.id} className={classes.root}>
            {view.name}
            {(view.is_main_view != 1 && (view.created_by == window.LOGGED_IN_USER.user_id || containerStore?.permissions.canChangeSettings())) &&
              <StyledIconButton
                size="small"
                className="icon"
                onClick={(e)=>{
                  e.stopPropagation();
                  handleClose();
                  handleEditReport(view.id);
                }}
              >
                <MdEdit size={16} />
              </StyledIconButton>
            }
          </MenuItem>
        ))}
        </div>
        <StyledDivider />
        <MenuItem
          style={{
            justifyContent: "flex-start",
          }}
          onClick={() => {setIsShowCreateViewOptions(true)}}
        >
          Create New Report
          <StyledArrowRightIcon
            ref={createViewRef}
          />
        </MenuItem>
        <Menu
          anchorEl={createViewRef.current}
          open={isShowCreateViewOptions}
          onClose={()=>{setIsShowCreateViewOptions(false)}}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <MenuItem 
            onClick={() => {
              handleCloseMenus();
              containerStore.handleCreateReport('table', false);
            }}
          >
            Standard Report
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCloseMenus();
              containerStore.handleCreateReport('pivot', false);
            }}
          >
            Pivot Report
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCloseMenus();
              containerStore.handleCreateReport('kanban', false);
            }}
          >
            Kanban Report
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCloseMenus();
              containerStore.handleCreateReport('chart', true);
            }}
          >
            Chart
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCloseMenus();
              containerStore.handleCreateReport('timeline', false);
            }}
          >
            Timeline
          </MenuItem>
        </Menu>
      </Menu>}
      {containerStore?.listConfig?.list?.is_log_sheet != 1 && ((typeof currentView.is_main_view != "undefined" && currentView.is_main_view != "null") && (currentView.created_by == window.LOGGED_IN_USER.user_id || containerStore?.permissions.canChangeSettings())) &&
      <SheetActions
        view={currentView}
        renameView={() => {
          setIsNameEditing(true);
        }}
        handleMarkasDefaultReport={(viewId) => markasDefaultReport(viewId)}
        handleEditReport={(viewId) => {
          handleEditReport(viewId);
        }}
        deleteView={(viewId) => {
          deleteView(viewId);
        }}
      />}
    </React.Fragment>
  );
}

function useData() {
  const containerStore = useContext(ContainerStoreContext);

  return useObserver(() => ({
    view: containerStore.view,
    views: containerStore.views,
    onViewChange: containerStore.handleViewChange,
    saveView: containerStore.saveView,
    containerStore: containerStore,
    handleEditReport: containerStore.handleEditReport,
    deleteView: containerStore.deleteView
  }));
}

function usePackData() {
  const packStore = useContext(PackStoreContext);

  return useObserver(() => ({
    renameSheet: packStore.handleRenameSheet,
    markasDefaultReport: packStore.handleMarkasDefaultReport,
  }));
}

const ViewName = styled.span`
  display: inline-block;
  overflow: hidden;
  max-width: ${(props) => (props.screenWidth <= 1401 ? "140px" : "140px")};
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  text-align: left;
  color: #212121;
`;

const ViewButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 5px;
`;

const StyledArrowRightIcon = styled(ArrowRightIcon)`
&& {
  width: 18px;
  height: 18px;
  position: absolute;
  right: 10px;
}
`;

const StyledIconButton = styled(IconButton)`
&& {
  width: 20px;
  height: 20px;
  margin-left:auto;
  color: #000000;
  cursor: default;
  &:hover {
    background-color: #ddd;
  }
}
`;

const StyledDivider = styled(Divider)`
&& {
  margin: 6px;
}
`;
export default observer(ReportsMenu);
